import { useDisclosure } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React, { memo, useMemo } from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import text from '../../../../utils/locale/languages/ES/Es.json'
import DenyEnrrollment from './DenyEnrrollment'
// import DenyEnrrollment from './DenyEnrrollment'
import ReasignEnrollment from './ReasignEnrollment'
const forActiveStyles = {
  textAlign: 'start',
  width: 'max-content',
  textDecoration: 'underline',
  color: 'blue',
  cursor: 'pointer',
}
export const statusTypes = {
  DV: text.unlinked,
  EP: text.in_process,
  AC: text.active,
  BL: text.locked,
  SU: text.suspended,
  PA: text.for_activate,
  RA: text.reasign,
}
const StatusCell = ({ value, data }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  const { texts } = useLabels()
  const status = data.original.sEstadoEnrolamiento
    ? data.original.sEstadoEnrolamiento
    : data.original.sEstado
  const label = useMemo(
    () => statusTypes[status],
    [texts.active, texts.unactive, texts.unlinked, value],
  )

  return (
    <>
      {status === 'PA' && (
        <DenyEnrrollment
          isOpen={isOpen}
          data={data.original}
          onClose={onClose}
        />
      )}
      {status === 'RA' && (
        <ReasignEnrollment
          isOpen={isOpen}
          data={data.original}
          onClose={onClose}
        />
      )}
      <div
        onClick={['PA', 'RA'].includes(status) ? onOpen : null}
        style={
          ['PA', 'RA'].includes(status)
            ? forActiveStyles
            : {
                textAlign: 'left',
              }
        }
      >
        {label}
      </div>
    </>
  )
}

StatusCell.propTypes = {
  value: PropTypes.string,
  data: PropTypes.object,
}

export default memo(StatusCell)
